<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 规则dialog
  -->
  <div>
    <!-- <div class="page-top-bar">
      <span class="close" @click.stop="$emit('closeRuleDetailDialog')">x</span>
      <span>{{gettext('规则详情')}}</span>
    </div> -->
    <div class="xtc-rules-button" @click.stop="ruleDetailClick">
      <span>{{gettext('规则详情')}}</span>
      <img src="https://img0.didiglobal.com/static/soda_public/do1_2UGECVFFWEENNcqtJdHD" />
    </div>
    <Popup :isShow="showRuleDialog" :title="gettext('规则详情')" @clickMask="showRuleDialog = false">
      <div class="popup-wrapper" slot="content">
        <div class="xtc-rules-container">
          <div class="page-content">
            <ul>
              <li v-for="(item, index) in ruleList" :key="index">{{index+1}}. {{item}}</li>
            </ul>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import Popup from '@/components/popup'
import { mapGetters } from 'vuex'
import currentTrans from '@/common/js/currency-config'
import trackEvent from '@/common/js/track'
import { setTitle } from '@/common/js/bridge'
import { getLocaleBrandText, getTelNum, getEmail } from '@/common/js/utils'
import { sprintf, getLanguageLong } from '@didi/gettext'
import rule from '../ruleConf.js'
export default {
  name: 'detailRules',
  data () {
    return {
      showRuleDialog: false,
      ruleList: []
    }
  },
  components: {
    Popup
  },
  computed: {
    ...mapGetters(['globalParams', 'acquisitionInfo']),
    country () {
      return this.$store.state.country
    },
    currentLang () {
      return getLanguageLong()
    },
    rewardInfo () {
      return (this.acquisitionInfo.recommendPage && this.acquisitionInfo.recommendPage.rewardInfo) || {}
    },
    rewardAmount () {
      return this.rewardInfo.amountSplit && this.rewardInfo.amountSplit.display
    }
  },
  methods: {
    ruleDetailClick () {
      this.showRuleDialog = true
    },
    getCurrency (current) {
      return (currentTrans[current] || currentTrans['']).symbol
    },
    getMoney (current, money, item) {
      if (!money) return 0
      let res = currentTrans[current] || currentTrans['']
      return parseInt(money / res.rate)
    },
    setRuleList () {
      switch (this.country) {
        case 'JP':
          this.ruleList = [
            this.$t(rule[13]),
            this.$t(rule[14], {productname_didi_food: getLocaleBrandText('brand_txt_2')}),
            this.$t(rule[15], {productname_didi_food: getLocaleBrandText('brand_txt_2')}),
            this.$t(rule[16], {productname_didi_food: getLocaleBrandText('brand_txt_2')}),
            this.$t(rule[17]),
            this.$t(rule[18], {activity_city: '', productname_didi_food: getLocaleBrandText('brand_txt_2')}),
            this.$t(rule[19]),
            this.$t(rule[20], {contact_email: getEmail(this.country)})
          ]
          break
        case 'CR':
          this.ruleList = [
            `${rule[1]}：${this.acquisitionInfo.recommendPage.startTimeDisplay}-${this.acquisitionInfo.recommendPage.endTimeDisplay}`,
            sprintf(rule[2], getLocaleBrandText('brand_txt_2'), this.rewardAmount),
            sprintf(rule[3], getLocaleBrandText('brand_txt_4')),
            sprintf(rule[4], getLocaleBrandText('brand_txt_2')),
            sprintf(rule[5], getLocaleBrandText('brand_txt_4')),
            rule[6],
            sprintf(rule[7], this.acquisitionInfo.cityNames || this.acquisitionInfo.cityName, getLocaleBrandText('brand_txt_2')),
            sprintf(rule[8], getLocaleBrandText('brand_txt_2')),
            rule[9],
            rule[10],
            rule[11],
            `${sprintf(rule[12], getLocaleBrandText('brand_txt_2'))}: ${getTelNum(this.country)}`,
            this.$t(rule[13]),
            this.$t(rule[21])
          ]
          break
        default:
          this.ruleList = [
            `${rule[1]}：${this.acquisitionInfo.recommendPage.startTimeDisplay}-${this.acquisitionInfo.recommendPage.endTimeDisplay}`,
            sprintf(rule[2], getLocaleBrandText('brand_txt_2'), this.rewardAmount),
            sprintf(rule[3], getLocaleBrandText('brand_txt_4')),
            sprintf(rule[4], getLocaleBrandText('brand_txt_2')),
            sprintf(rule[5], getLocaleBrandText('brand_txt_4')),
            rule[6],
            sprintf(rule[7], this.acquisitionInfo.cityNames || this.acquisitionInfo.cityName, getLocaleBrandText('brand_txt_2')),
            sprintf(rule[8], getLocaleBrandText('brand_txt_2')),
            rule[9],
            rule[10],
            rule[11],
            `${sprintf(rule[12], getLocaleBrandText('brand_txt_2'))}: ${getTelNum(this.country)}`,
            this.$t(rule[13])
          ]
          break
      }
    }
  },
  created () {
    setTitle(this.gettext('推荐有奖'))
    this.setRuleList()
    trackEvent({
      eventId: 'sailing_c_x_invitation_rule_detail_sw',
      eventLabel: '推荐有奖详细规则',
      attrs: {
        from_page: 'CC',
        activity_id: this.acquisitionInfo.activityID
      }
    })
  }
}
</script>
<style lang="stylus" scoped>
.xtc-rules-button {
    display: flex;
    align-items: center;
    margin: 32px 0 80px 24px;
    span {
      height: 28px;
      // font-family: DiDiSansPro-Regular;
      font-family: 'Aspira Regular';
      font-size: 28px;
      color: #666666;
      line-height: 28px;
      font-weight: 400;
    }
    img {
      margin-left: 11.04px;
      width: 20px;
      height: 20px;
    }
  }
  .popup-wrapper {
    margin-top 43px
    height 100%
    overflow-y auto
  }
.xtc-rules-container {
  background: #ffffff;
  height: calc(100vh - 100px);
  border-radius: 20px;
  .page-top-bar {
    .close {
      position: absolute;
      left: 40px;
      font-size: 59px;
    }
    height: 110px;
    line-height: 110px;
    text-align: center;
    font-size: 36px;
    color: #000000;
  }
  .page-content {
    font-family: 'Aspira Regular';
    font-size: 24px;
    color: #666666;
    text-align: left;
    line-height: 28px
    margin: 0 40px 127px;
    text-align: left;
    font-size: 26px
    ul {
      line-height 42px
    }
  }
}
</style>
